export const SoftwareIcon = ({ id }) => (
  <svg width="119" height="90" viewBox="0 0 119 90" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="119" height="90" fill="white" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M46.3084 16.662C46.3084 10.2213 51.5296 5 57.9704 5C79.6724 5 97.2578 22.5854 97.2578 44.2874C97.2578 65.9895 79.6724 83.5748 57.9704 83.5748H14.662C8.22126 83.5748 3 78.3536 3 71.9128C3 65.4721 8.22126 60.2508 14.662 60.2508H57.9704C66.7909 60.2508 73.9338 53.108 73.9338 44.2874C73.9338 35.4669 66.7909 28.324 57.9704 28.324C51.5296 28.324 46.3084 23.1028 46.3084 16.662Z"
      fill="url(#paint0_linear_2426_1297)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.3438 44.2874C19.3438 22.5854 36.9291 5 58.6312 5C65.0719 5 70.2932 10.2213 70.2932 16.662C70.2932 23.1028 65.0719 28.324 58.6312 28.324C49.8106 28.324 42.6678 35.4669 42.6678 44.2874C42.6678 53.108 49.8106 60.2508 58.6312 60.2508H106.503V83.5748H58.6312C36.9291 83.5748 19.3438 65.9895 19.3438 44.2874Z"
      fill="#00CA72"
    />
    <path
      d="M116.834 69.1374C118.389 70.6837 118.389 73.1999 116.834 74.7462L109.094 82.4428C106.6 84.9237 102.35 83.1567 102.35 79.6384L102.35 64.2452C102.35 60.7269 106.6 58.9599 109.094 61.4408L116.834 69.1374Z"
      fill="#00CA72"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2426_1297"
        x1="74.4638"
        y1="31.3159"
        x2="67.4632"
        y2="63.8687"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00CA72" />
        <stop offset="0.905957" stop-color="#00CA72" stop-opacity="0.6" />
      </linearGradient>
    </defs>
  </svg>
);
